.passwordForm {
	@apply yst-space-y-6;
}
